import { TrendLabel } from '@/api/rest/resources/conservation';
import { R1FactType } from '@/api/rest/resources/types/fact';
import { useOrganizationIndicatorReportingFact } from '@/pages/shared/hooks/useOrganizationFact';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';
import { isNullish } from '@/utils/booleans';

export const useTrendLabelFromOrganizationFact = ({ fact }: { fact: R1FactType }): TrendLabel | null => {
  const { [fact]: factData } = useOrganizationIndicatorReportingFact<number>(fact);
  const factValue = factData?.value;

  if (isNullish(factValue) || typeof factValue !== 'number') {
    return null;
  }

  if (factValue >= 5) {
    return TrendLabel.increasing;
  }

  if (factValue <= -5) {
    return TrendLabel.decreasing;
  }

  return TrendLabel.stable;
};

export const useTrendLabelFromPlotFact = ({ fact }: { fact: R1FactType }): TrendLabel | null => {
  const facts = usePlotFacts<number>([fact]);
  const factValue = getFactFromFactArray<number>(facts, fact)?.value;

  if (isNullish(factValue) || typeof factValue !== 'number') {
    return null;
  }

  if (factValue >= 5) {
    return TrendLabel.increasing;
  }

  if (factValue <= -5) {
    return TrendLabel.decreasing;
  }

  return TrendLabel.stable;
};
